import { render, staticRenderFns } from "./midContent.vue?vue&type=template&id=53b1b38f&"
import script from "./midContent.vue?vue&type=script&lang=js&"
export * from "./midContent.vue?vue&type=script&lang=js&"
import style0 from "./midContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports